module.exports = __webpack_public_path__ + "19d16288.svg";